
export const NOMINA_ACTIVE = process.env.REACT_APP_NOMINA_ACTIVE === "FALSE";
export const PABS_ACTIVE = process.env.REACT_APP_PABS_ACTIVE === "TRUE";
export const PERSONAL_ACTIVE = process.env.REACT_APP_PERSONAL_ACTIVE === "TRUE";
//export const API_URL = 'http://127.0.0.1:3000/api';
export const API_URL = 'https://app.percapita.mx/api';
